import cloneDeep from 'lodash/cloneDeep'

export function createUniqueDeepClone<T extends object>(obj: T) {
  const newObj = cloneDeep(obj) as T & { id: number; _new: true }
  newObj.id = Number(Date.now().toString())
  newObj._new = true
  return newObj
}
